import React from 'react'

import CruisesBookingCard from './CruisesBookingCard'

import BedBankBookingCard from 'tripPlanner/components/Bookings/BedBankBookingCard'
import ExperienceBookingCard from 'tripPlanner/components/Bookings/ExperienceBookingCard'
import FlightBookingCard from 'tripPlanner/components/Bookings/FlightBookingCard'
import HotelBookingCard from 'tripPlanner/components/Bookings/HotelBookingCard'
import TourV2BookingCard from 'tripPlanner/components/Bookings/TourV2BookingCard'
import { OfferTypeForTripItemTypes } from 'tripPlanner/hooks/api/common'

type Props = {
  order: App.Order
  onSelect?: (
    order: App.Order,
    offers: Array<OfferTypeForTripItemTypes>,
    checked: boolean,
  ) => void
}

function SingleTypeItemBookingCard(props: Props) {
  const { order } = props

  const {
    items,
    bedbankItems,
    flightItems,
    tourItems,
    experienceItems,
    cruiseItems,
  } = order

  if (bedbankItems.length > 0) {
    return (
      <BedBankBookingCard
        order={order}
        bedbankOrderItem={order.bedbankItems[0]}
        onSelect={props.onSelect}
      />
    )
  }

  if (flightItems.length > 0) {
    return (
      <FlightBookingCard
        order={order}
        orderFlightItem={order.flightItems[0]}
        onSelect={props.onSelect}
      />
    )
  }

  if (items.length > 0) {
    return (
      <HotelBookingCard
        order={order}
        orderItem={order.items[0]}
        onSelect={props.onSelect}
      />
    )
  }

  if (tourItems.length > 0) {
    return (
      <TourV2BookingCard
        order={order}
        tourV2OrderItem={tourItems[0]}
        onSelect={props.onSelect}
      />
    )
  }

  if (experienceItems.length > 0) {
    return (
      <ExperienceBookingCard
        experienceItem={experienceItems[0]}
        order={order}
        onSelect={props.onSelect}
      />
    )
  }

  if (cruiseItems.length > 0) {
    return (
      <CruisesBookingCard
        order={order}
        orderItem={cruiseItems[0]}
        onSelect={props.onSelect}
      />
    )
  }

  return null
}

export default SingleTypeItemBookingCard
